import React from 'react'

import CMYK from 'shared/entities/CMYK'
import RGB from 'shared/entities/RGB'

export type ReactChildren = {
  children: React.ReactNode
}

export type StyledComponentWithCompound = React.ComponentType<any> & {
  [key: string]: React.ComponentType<any>
}

export enum Locales {
  en = 'en',
  de = 'de'
}

export enum FileTypes {
  image = 'image',
  pdf = 'pdf'
}

export enum ImageFormats {
  png = 'png',
  jpg = 'jpg'
}

export enum EnvTypes {
  dev = 'DEV',
  stage = 'STAGE',
  prod = 'PROD'
}

export type LiveUser = {
  id: string
  avatar: string
  firstName: string
  lastName: string
  initials: string
  index: number
}

export enum ColorTypes {
  rgb = 'RGB',
  cmyk = 'CMYK'
}

export enum CMYKValues {
  c = 'c',
  m = 'm',
  y = 'y',
  k = 'k'
}

export enum RGBValues {
  r = 'r',
  g = 'g',
  b = 'b'
}

export type ColorCMYK = Record<CMYKValues, number>
export type ColorRGB = Record<RGBValues, number>

export type Color = CMYK | RGB

export enum PageTemplateTypes {
  blank = 'blank',
  collages = 'collages',
  reports = 'reports',
  quotes = 'quotes',
  profile = 'profile',
  rankings = 'rankings'
}

export type Base64String = string

export type Percent = number
export type Millimeters = number
export type Pixels = number

export type Size<T = number> = {
  width: T
  height: T
}
export type Coordinates<T = number> = {
  x: T
  y: T
}

export type Seconds = number
export type Milliseconds = number

export enum ImageSources {
  internal = 'internal',
  collage = 'collage',
  profile = 'profile',
  report = 'report',
  custom = 'custom'
}

export enum PageWorkflowStatus {
  default = 'default',
  final = 'final',
  inProgress = 'inProgress',
  inReview = 'inReview'
}

export enum CoverTypes {
  soft = 'soft',
  hard = 'hard'
}

export enum CoverSides {
  inside = 'inside',
  outside = 'outside'
}

export enum CoverParts {
  front = 'front',
  spine = 'spine',
  back = 'back'
}

export type Url = string
export type Base64 = string

export enum AutomationEntities {
  profiles = 'profiles',
  quotes = 'quotes',
  collages = 'collages',
  rankings = 'rankings',
  reports = 'reports'
}
